import { Icon, Space, Tooltip, Typography } from '@sravni/react-design-system';
import { Tip } from '@sravni/react-icons';

import { OrganizationLogo } from '../OrganizationLogo';

import styles from './heading-block.module.scss';

interface IProps {
  heading: string;
  logoSrc: string;
  isPartner: boolean;
  productLogo?: string;
  rating?: number;
  urlRating: string;
}

export const HeadingBlock: React.FC<IProps> = ({ logoSrc, isPartner, productLogo, heading, rating, urlRating }) => (
  <Space align="center" size={16}>
    <OrganizationLogo logoSrc={logoSrc} productLogo={productLogo} isPartner={isPartner} />
    <Space direction="vertical" size={4}>
      <Typography.Heading level={3}>{heading}</Typography.Heading>
      <Space size={4} direction="horizontal" align="center">
        <div className={styles.label}>
          <Typography.Link href={urlRating} className={styles.link} />
          <Typography.Text size={12}>
            {rating ? (
              <>
                Рейтинг <strong>{rating.toFixed(2)}</strong> из 5
              </>
            ) : (
              'Без рейтинга'
            )}
          </Typography.Text>
        </div>
        {!rating && (
          <Tooltip title="Рейтинг пока не сформирован, так как данных о компании и отзывов пока недостаточно">
            <Icon icon={<Tip />} className={styles.iconTip} />
          </Tooltip>
        )}
      </Space>
    </Space>
  </Space>
);
